module.exports = __webpack_public_path__ + "static/img/dr_mallath_photo.5784a36b.png";